export enum MerchandiseDimensionType {
  PACK_LOAD = 'pack_load',
  ORDER_LOAD = 'order_load'
}
